import {memo} from 'react';

import {ThreadViewer} from './thread_viewer';

export default memo(ThreadViewer);
